import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-704d7c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "v-im"
}
const _hoisted_2 = {
  class: "left-bar",
  style: {"-webkit-app-region":"drag"}
}
const _hoisted_3 = { class: "userPhoto" }
const _hoisted_4 = { title: "会话" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-liaotian" }, null, -1))
const _hoisted_6 = { title: "好友" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-haoyou" }, null, -1))
const _hoisted_8 = { title: "组织" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-bumen" }, null, -1))
const _hoisted_10 = { title: "群" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-qunzhong" }, null, -1))
const _hoisted_12 = { title: "设置" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-shezhi" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-weibiaoti2" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

import showUser from "@/components/user-modal/";
import Avatar from "@/components/Avatar.vue";
import { useUserStore } from "@/store/userStore";
import { useChatStore } from "@/store/chatStore";
import AccountApi from "@/api/AccountApi";

import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive
} from "vue";
import Auth from "@/api/Auth";
import Message from "@/mode/Message";
import ChatType from "@/config/ChatType";
import ChatUtils from "@/utils/ChatUtils";
import vimConfig from "@/config/VimConfig";
import { ElMessageBox } from "element-plus/es";
import { logout } from "@/api/Login";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { proxy } = getCurrentInstance();
const userStore = useUserStore();
const chatStore = useChatStore();
const currentUser = userStore.getUser();
if (!currentUser) {
  AccountApi.toLogin();
}
const userConf = reactive({
  show: false,
  userId: ""
});
const unreadCount = computed(() => {
  let i = 0;
  chatStore.chats.forEach((item) => {
    i = i + item.unreadCount;
  });
  return i;
});

const vimLogout = () => {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning"
  }).then(() => {
    logout().then(() => {
      proxy.$ws.close();
      AccountApi.toLogin()
    });
  });
};

onMounted(() => {
  if (currentUser) {
    //初始化websocket
    chatStore.reset();
    proxy.$ws.init(
      vimConfig.wsProtocol +
      "://" +
      Auth.getIp() +
      ":" +
      vimConfig.wsPort +
      "?token=" +
      Auth.getToken()
    );
    //重写 onmessage 方法，收到的消息都在这里进行分发
    proxy.$ws.onmessage = (message: Message) => {
      //群聊里面，自己发的消息不再显示
      if (currentUser.id === message.fromId) {
        message.mine = true;
      }else {
        proxy.$winControl.default.flashIcon();
        proxy.$winControl.default.flashFrame();
      }
      //友聊换chatId,chatId 不一样
      if (
        ChatType.FRIEND === message.type &&
        currentUser.id !== message.fromId
      ) {
        message.chatId = message.fromId;
      }
      chatStore.pushMessage(message);

      nextTick(() => {
        ChatUtils.imageLoad("message-box");
      });
    };
    userConf.userId = currentUser.id;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(currentUser))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_3, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(showUser)(_unref(userStore).getUser().id, false)))
              }, [
                _createVNode(Avatar, {
                  img: _unref(userStore).getUser().avatar,
                  name: _unref(userStore).getUser().name
                }, null, 8, ["img", "name"])
              ])
            ]),
            _createElementVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, { to: '/index/chat' }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_badge, {
                    value: unreadCount.value,
                    hidden: unreadCount.value === 0
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["value", "hidden"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: '/index/friend' }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, { to: '/index/dept' }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, { to: '/index/group' }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, { to: '/index/system/user' }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", {
              title: "退出",
              class: "logout",
              onClick: vimLogout
            }, _hoisted_15)
          ])
        ]),
        _createVNode(_component_router_view, { class: "content" }, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})